import type { MenuSection } from '@botto/core';

export const menu: MenuSection = {
  id: 'tariffs',
  title: 'Тарифы',
  icon: 'money',
  items: [
    { title: 'Тарифы', to: '/tariffs/list', icon: 'tags' },
    { title: 'Пользователи', to: '/tariffs/users', icon: 'group' },
    { title: 'Шаблоны закупки', to: '/tariffs/buy-templates', icon: 'copy' },
    { title: 'Страны', to: '/tariffs/countries', icon: 'globe' },
    { title: 'Операторы', to: '/tariffs/operators', icon: 'tel' },
    { title: 'Транзакции', to: '/tariffs/transactions', icon: 'card' },
  ],
};
